module.exports = __webpack_public_path__ + "static/media/MTL_ASC_TNK2.171b9a19.png";